import moment from 'moment'
import { useSnackbar } from 'notistack'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { AiOutlineInbox } from 'react-icons/ai'
import { useHistory, useParams } from 'react-router-dom'
import { Checkbox, Drawer, Tabs, Upload } from 'antd'

import { usePet, useToggle, notifOps, server } from '../../modules'

import Datepicker from "../reusable/datePicker"
import Confirm from '../reusable/confirm'

const { Dragger } = Upload
const { TabPane } = Tabs

const NewStockTake = ({ store, onPerform }) => {
    const [startedOn, setStartedOn] = useState()
    const [completedOn, setCompletedOn] = useState()
    const [desc, setDesc] = useState()
    const [file, setFile] = useState([])
    const [type, setType] = useState()
    const [date, setDate] = useState(moment())

    const [visible, toggleVisible] = useToggle(true)
    const [ignoreZero, toggleZero] = useToggle(true)

    const { enqueueSnackbar } = useSnackbar()

    const { params } = useSelector(state => state.application)

    const history = useHistory()
    const { id } = useParams()

    const disabledDate = current => current > moment() && current < moment().subtract(2, 'days')

    const props = {
        name: 'stockTakeList',
        fileList: file,
        action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        onChange: info => {
            let { fileList } = info
            fileList = fileList.slice(-1)
            let temp = fileList[0]
            console.log(temp.type)
            const isOK = temp?.type === 'text/csv' || temp.type === 'application/vnd.ms-excel' || temp.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            if (!isOK) {
                enqueueSnackbar('Please upload a microsoft excel format file', notifOps('warning'))
                return false
            }
    
            let isLarge = (temp?.size / 1024 / 1024) > params?.maxFileUploadSize
            if (isLarge)
                enqueueSnackbar(`Please upload a file smaller than ${params?.maxFileUploadSize} MB`, notifOps('warning'))
            
            if (isOK && !isLarge) {
                setFile(fileList)
                setType(temp?.type)
            }
        },
        beforeUpload: () => false,
        onDrop: (e) => {
            console.log('Dropped files', e.dataTransfer.files);
        },
    }

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 100)
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('File has been uploaded. Please check back later for progress.', ops('success'))
        
        setTimeout(close, 300)
    }

    const [{ loading }, upload] = usePet('newStockTake', {
        desc,
        date,
        ignoreZero,
        store: store?.value,
        startedOn,
        completedOn,
        stocktakelist: file[0]?.originFileObj
    }, { hasFile: true, notify: true, callback: onComplete, manual: true })

    const [{ loading: tLoading }, testSheet] = usePet('testStockTake', {
        desc,
        date,
        ignoreZero,
        store: store?.value,
        stocktakelist: file[0]?.originFileObj
    }, { hasFile: true, notify: true, callback: onComplete, manual: true })

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button disabled={ tLoading } onClick={ () => Confirm({
                        title: 'Test Stock Take Sheet?',
                        message: `This has no effect on the stock values for ${store?.label}.`,
                        onOk: testSheet,
                        okText: 'Test Stock Take Sheet',
                    }) } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Test Sheet</button>
                    <button disabled={ loading } onClick={ () => Confirm({
                        title: 'Upload Stock Take?',
                        message: `This will affect the stock values for ${store?.label}.`,
                        onOk: upload,
                        okText: 'Upload Stock Take',
                    }) } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Upload Sheet</button>
                </div>
            }
            width={500}>
            <p className="font-extrabold text-3xl mb-0">Upload Stock Take</p>
            <p className="text-gray-500 text-xs mt-0"></p>
            <div className="divide-y divide-light-gray-400">
                <div className="w-full mt-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Stock Take Date/Time
                    </label>
                    <Datepicker
                        showTime
                        value={ date }
                        onChange={ setDate } 
                        disabledDate={ disabledDate } />
                </div>
                <div className="w-full mt-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Started On
                    </label>
                    <Datepicker
                        showTime
                        value={ startedOn }
                        onChange={ setStartedOn }
                        disabledDate={ disabledDate } />
                </div>
                <div className="w-full mt-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Completed On
                    </label>
                    <Datepicker
                        showTime
                        value={ completedOn }
                        onChange={ setCompletedOn }
                        disabledDate={ disabledDate } />
                </div>
                <div className="w-full px-3 mb-2">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" htmlFor="grid-username">
                        Ignore Zero Values
                    </label>
                    <Checkbox className="mb-2" checked={ ignoreZero } onChange={ toggleZero }>Ignore Zero Values</Checkbox> 
                </div>
                <div className="w-full mt-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Notes
                    </label>
                    <textarea
                        rows="5"
                        value={ desc }
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        onChange={e => setDesc(e.target.value) } />
                </div>
                <div className="w-full pt-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Upload File
                    </label>
                    <Dragger {...props}>
                        <p className="ant-upload-drag-icon flex justify-center">
                            <AiOutlineInbox size={40} />
                        </p>
                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                        <p className="ant-upload-hint">Please select a excel file (csv/xslx)</p>
                    </Dragger>
                </div>
            </div>
        </Drawer>
    )
}

export default NewStockTake